/**
 * A PDF the app already holds as an object URL: shown inline where the browser can show all of
 * it, otherwise handed to the device's own viewer (RESP-08: a framed PDF is blank on Android and
 * stops at the first page on iPhone and iPad). `className` sizes the inline frame.
 */

import { canShowPdfInline } from "../../lib/pdfInline";

export function PdfView({ url, filename, className = "" }: { url: string; filename: string; className?: string }) {
  if (canShowPdfInline()) return <iframe src={url} title={filename} className={className} />;
  return (
    <div className="flex flex-col items-center gap-3 rounded-lg border bg-gray-50 px-4 py-8 text-center">
      <p className="max-w-xs text-sm text-gray-600">This PDF opens in your device's own viewer, which shows every page.</p>
      <div className="flex flex-wrap justify-center gap-2">
        <a href={url} target="_blank" rel="noreferrer" className="btn-primary">
          Open PDF
        </a>
        <a href={url} download={filename} className="btn-secondary">
          Download
        </a>
      </div>
    </div>
  );
}
